import { Reducer } from 'redux'
import { ILessonModel } from 'models/lesson.model'
import { QuestionTypeEnum } from 'enum'
import * as fromActions from '../actions/lessons.action'
import { ILessonState, SurveyQuestionsForm } from '../states/lessons.state'
import { BlockTypes } from '../../enum/block-type.enum'

export const initialState: ILessonState = {
  lesson: {} as ILessonModel,
  currentLessonContent: [],
  lessonInfo: {},
  loading: false,
}

export const reducer: Reducer<ILessonState> = (
  state: ILessonState = initialState,
  { type, payload }
) => {
  switch (type) {
    case fromActions.LESSONS_GET_LESSON:
      return {
        ...state,
        loading: true,
      }
    case fromActions.LESSONS_GET_LESSON_SUCCESS:
      return {
        ...state,
        lesson: payload,
        // loading: false,
      }
    case fromActions.LESSONS_GET_LESSON_CONTENT: {
      return {
        ...state,
        loading: true,
      }
    }
    case fromActions.LESSONS_GET_LESSON_CONTENT_SUCCESS:
      return {
        ...state,
        currentLessonContent: payload,
        loading: false,
      }

    case fromActions.LESSONS_SET_ATTACHMENTS_TASK: {
      const { index, data } =
        payload as fromActions.LessonsSetAttachmentsTaskParams
      return {
        ...state,
        currentLessonContent: state.currentLessonContent.map((item, i) => {
          if (i === index && item.type === BlockTypes.BlockTask) {
            return {
              ...item,
              response: { ...item.response, attachments: data },
            }
          }
          return item
        }),
      }
    }
    case fromActions.LESSONS_REMOVE_ATTACHMENT_TASK: {
      const { index, token } =
        payload as fromActions.LessonsRemoveAttachmentTaskParams
      return {
        ...state,
        currentLessonContent: state.currentLessonContent.map((item, i) => {
          if (i === index && item.type === BlockTypes.BlockTask) {
            const attachments = item.response?.attachments.filter(
              (attachment) => attachment.token !== token
            )
            return {
              ...item,
              response: { ...item.response, attachments: attachments || [] },
            }
          }
          return item
        }),
      }
    }

    case fromActions.LESSONS_SURVEY_SET_QUESTION_RESPONSE: {
      const { index, questionIndex, value } =
        payload as fromActions.LessonsSetQuestionResponseParams
      return {
        ...state,
        currentLessonContent: state.currentLessonContent.map((item, i) => {
          if (i === index && item.type === BlockTypes.BlockSurvey) {
            return {
              ...item,
              questionsForms: item.questionsForms.map(
                (question, j): SurveyQuestionsForm => {
                  if (j === questionIndex) {
                    const { likert, openEnded } = QuestionTypeEnum
                    if (
                      question.questionableType === likert &&
                      value.type === likert
                    )
                      return {
                        ...question,
                        answer: value.answer,
                      }
                    if (
                      question.questionableType === openEnded &&
                      value.type === openEnded
                    )
                      return {
                        ...question,
                        answer: value.answer,
                      }
                  }
                  return question
                }
              ),
            }
          }
          return item
        }),
      }
    }

    case fromActions.LESSONS_GET_NEXT_LESSON:
      return {
        ...state,
        lessonInfo: payload,
        loading: true,
      }
    default:
      return {
        ...state,
      }
  }
}
